import { ErrorHandler, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppErrorService } from './app-error.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private appError: AppErrorService, private router: Router) {}

  handleError(error: unknown): void {
    const currentPath = this.router.url || undefined;
    this.appError.reportRuntime(error, currentPath);
  }
}
